module.exports = __webpack_public_path__ + "img/IMG_7189_L_WoodMatted.325b85d6.jpg";